<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { PlayerTrack } from '~/stores/player'
import PublicCreatorBadge from '../creator/PublicCreatorBadge.vue'
defineProps<{ creator?: PlayerTrack['creator'] }>()
const { t } = useI18n()
</script>

<template>
  <span class="creator-credit">
    <span class="creator-avatar" data-live :style="{ '--live-h': creator?.avatar?.hue ?? 152 }" aria-hidden="true">
      <img v-if="creator?.avatar?.url" :src="creator.avatar.url" width="24" height="24" alt="" />
      <template v-else>{{ creator?.avatar?.initial || '' }}</template>
    </span>
    <span class="creator-name">{{ creator?.display_name || t('ux.creatorUnavailable') }}</span>
    <PublicCreatorBadge v-if="creator?.display_badge || creator?.badges?.length" :badge="creator.display_badge || creator.badges?.[0]" :fallback-label="t('mm.song.creatorBadge', { name: creator.display_name })" :size="18" />
  </span>
</template>

<style scoped>
.creator-credit { display: inline-flex; align-items: center; gap: var(--s-2); min-width: 0; }
.creator-avatar { display: grid; place-items: center; flex: none; width: 24px; height: 24px; border-radius: var(--r-pill); background: var(--live-soft); color: var(--live); overflow: hidden; font: 600 var(--t-micro)/1 var(--font-ui); }
.creator-avatar img { width: 24px; height: 24px; object-fit: cover; }
.creator-name { color: var(--text); font-weight: 600; overflow-wrap: anywhere; }
.creator-badge { display: inline-flex; color: var(--accent-text); }
</style>
